import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { STATUS_UPDATE_ACTION } from '../../constants/jobOrderConstants';

import {
  clearTimeCardErrorV2,
  postPlacementApprovalV2,
  postPlacementFinalizeV2,
  postPlacementResolveV2,
  postPlacementUnFinalizeV2,
  timecardEditV2ForJobOrderV2,
  updatePlacementCheckInStatusV2,
} from './jobOrdersReducer';

// eslint-disable-next-line import/prefer-default-export
export function useJobOrdersV2Actions() {
  const dispatch = useDispatch();

  const onPlacementCheckStatusUpdate = useCallback(
    (data) => {
      dispatch(updatePlacementCheckInStatusV2(data));
    },
    [dispatch]
  );

  const clearTimeCardError = useCallback(() => {
    dispatch(clearTimeCardErrorV2());
  }, [dispatch]);

  const handleTimecardEditSubmit = useCallback(
    (data) => {
      dispatch(timecardEditV2ForJobOrderV2(data));
    },
    [dispatch]
  );

  const onStatusUpdate = useCallback(
    (data) => {
      const status = data?.status;
      const placementId = data?.placementId;
      if (!placementId || !status) return;

      if (status === STATUS_UPDATE_ACTION.APPROVE) {
        dispatch(
          postPlacementApprovalV2({
            filters: [{ field: '_id', operation: 'idContainedIn', value: [placementId] }],
          })
        );
        return;
      }
      if (status === STATUS_UPDATE_ACTION.RESOLVE) {
        dispatch(
          postPlacementResolveV2({
            filters: [{ field: '_id', operation: 'idContainedIn', value: [placementId] }],
          })
        );
        return;
      }
      if (status === STATUS_UPDATE_ACTION.FINALIZE) {
        dispatch(
          postPlacementFinalizeV2({
            filters: [{ field: '_id', operation: 'idContainedIn', value: [placementId] }],
          })
        );
        return;
      }
      if (status === STATUS_UPDATE_ACTION.UNFINALIZE) {
        dispatch(postPlacementUnFinalizeV2({ placements: [placementId] }));
      }
    },
    [dispatch]
  );

  return {
    onPlacementCheckStatusUpdate,
    clearTimeCardError,
    handleTimecardEditSubmit,
    onStatusUpdate,
  };
}
